<div class="article">
  <div class="entry-cover" *ngIf="article">
    <div class="entry-cover-image" [title]="article.coverAlt" style="background-image: url({{article.imageCover}});">
    </div>
    <header class="entry-header" style="bottom: 30px; opacity: 1;">
      <div class="entry-info">
        <h1 class="entry-title" [style.color]="article.titleColor">{{ article.title }}</h1>
      </div>
    </header>
  </div>

  <div class="row container" *ngIf="article">
    <div class="col-md-8">
      <div class="ext">
        <div class="flex-elem" (click)='tip()'>
          <img class="mug" src="/assets/img/mug-heart-color.svg" alt="happygaytv icon">
          {{'data.tips.like' | translate }}
        </div>
        <div *ngIf="!isClub3" class="flex-elem flex-elem-margin" (click)='connection()'>
          <i class="fas fa-bell"></i>
          {{'data.subscribe' | translate}}
        </div>
        <div class="flex-elem flex-elem-margin" (click)='showShareModal(currentVideo)'>
          <i class="fas fa-share"></i>
          {{'data.share' | translate}}
        </div>
      </div>
      <div class="col-md-12 mt-4" *ngIf="article">
        <div style="margin-top:5vh" [innerHTML]="article.html | safeHtml"></div>
      </div>
      <div class="ext">
        <div class="flex-elem" (click)='tip()'>
          <img class="mug" src="/assets/img/mug-heart-color.svg" alt="happygaytv icon">
          {{'data.tips.like' | translate }}
        </div>
        <div *ngIf="!isClub3" class="flex-elem flex-elem-margin" (click)='connection()'>
          <i class="fas fa-bell"></i>
          {{'data.subscribe' | translate}}
        </div>
        <div class="flex-elem flex-elem-margin" (click)='showShareModal(currentVideo)'>
          <i class="fas fa-share"></i>
          {{'data.share' | translate}}
        </div>
      </div>
    </div>
    <app-video-slider style="width: 100%" *ngIf="relatedPost && relatedPost.length > 0" [articles]="relatedPost" [title]="'data.article.related-post' | translate">
    </app-video-slider>
  </div>
</div>
